<template>
  <modal class="modal-languages" v-if="show" @close="hide">
    <h3 slot="header">{{$resx('HomeChooseLanguageText')}}</h3>
    <div slot="body">
      <form method="post" action="/setLanguage" class="text-center">
        <select name="culture" class="select">
          <option v-for="cult in cultures" :value="cult.value" :key="cult.value" :selected="cult.value==currentCulture" >{{cult.text}}</option>
        </select>
        <input type="hidden" name="returnUrl" :value="currentUrl" />
        <button type="submit" class="btn btn-primary">{{$resx('ValidateText')}}</button>
      </form>
    </div>
  </modal>
</template>

<script>
import modal from './modal.vue'

export default {
  props: {
    show: Boolean
  },
  computed: {
    cultures () {
      return this.$store.state.app.supportedCultures
    },
    currentCulture () {
      return this.$store.state.app.culture
    },
    currentUrl () {
      return this.$route.fullPath
    }
  },
  methods: {
    // cacher la fentrer
    hide () {
      this.$emit('update:show', false)
    }
  },
  components:
  {
    modal: modal
  }
}
</script>

<style lang="less">
@import '../assets/variables.less';

  .modal-languages {
    .modal-container
    {
      max-width: 50em;
    }

    button,select
    {
      width:100%;
      max-width:30em;
      margin:1em auto;
    }
  }
</style>
